import AuthCard from '@/pages/authentication/AuthCard/AuthCard.tsx';
import useGetAuthentication from '@/domains/authentication/useGetAuthentication.ts';
import AuthenticationPageWrapper from '@/features/Pages/AuthenticationWrapper/AuthenticationPageWrapper.tsx';
import RedirectLoginUserType from '@/pages/authentication/navigation/RedirectLoginUserType.tsx';

const App = () => {
  const { data, isLoading } = useGetAuthentication();

  return (
    <AuthenticationPageWrapper
      backgroundImage={data?.pageData?.attributes?.backgroundImage || ''}
      isLoading={isLoading}
    >
      <RedirectLoginUserType />
      <AuthCard />
    </AuthenticationPageWrapper>
  );
};

export default App;
